/**
 * 規約をモーダルで表示する
 *
 */

/**
 * 規約モーダルウィンドウイベントを登録する
 */
function registPolicyModalEvent() {
	let PolicyModal = {
		/** スクロール位置保存用 */
		_currentScrollY: 0,
		/**
		 * モーダルを開く共通処理
		 * スクロールをロックし、前処理・後処理を実行してオーバーレイを表示する
		 * @param {jQuery} clickElement モーダルを開くボタン
		 * @param {jQuery} modalElement モーダルの枠(class="js-modal-window")
		 * @param {Function} beforeFunc オーバーレイ表示前に実行する関数
		 * @param {Function} afterFunc オーバーレイ表示後に実行する関数
		 */
		open: function(clickElement, modalElement, beforeFunc, afterFunc) {
			// スクロール位置保存、固定
			this._lockScroll();
			// 前処理
			if (typeof(beforeFunc) === 'function') beforeFunc(clickElement, modalElement);
			// オーバーレイ表示（共通実装に合わせて children() を使用）
			modalElement.children('.js-policy-modal-window-box').fadeIn('fast', function(){
				// モーダルの中身表示
				modalElement.children('.js-policy-modal-window-box-inner').show();
				// 後処理
				if (typeof(afterFunc) === 'function') afterFunc(clickElement, modalElement);
			});
		},
		
		/**
		 * モーダルを閉じる共通処理
		 * 前処理・後処理を実行してオーバーレイを非表示にし、スクロールロックを解除する
		 * @param {Function} beforeFunc オーバーレイ非表示前に実行する関数
		 * @param {Function} afterFunc オーバーレイ非表示後に実行する関数
		 */
		close: function(beforeFunc, afterFunc) {
			// 前処理
			if (typeof(beforeFunc) === 'function') beforeFunc();
			// オーバーレイ非表示
			$('.js-policy-modal-window-box:visible').fadeOut();
			// モーダルの中身非表示
			$('.js-policy-modal-window-box-inner:visible').fadeOut();
			// 後処理
			if (typeof(afterFunc) === 'function') afterFunc();
			// スクロール位置復元、固定解除
			this._unlockScroll();
		},
		
		/**
		 * スクロール位置を保存し、スクロールを固定する
		 * iOS15のバグ対策として異なるスタイルを適用する
		 */
		_lockScroll: function() {
			this._currentScrollY = $(window).scrollTop();
			if(location.pathname.indexOf('iphone') !== -1){
				//'iphone'つきのURLを参照していたらSPと判定

				// iOS15のバグでアドレスバーの背景だけ表示されて見た目が変なため、bodyにmin-height:100vh; orverflow:hidden; を設定することで対処
				// 正しいやり方かどうか不明。後から検証したほうが良い
				$('body').css('min-height', '100vh');
				$('body').css('overflow', 'hidden');
				// $('body').css('position', 'fixed');
				// $('body').css('width', '100%');
				// $('body').css('top', -1 * this._currentScrollY);
			} else {
				//それ以外は全てPCと判定
				$('body').css('overflow', 'hidden');
			}
		},
		
		/**
		 * スクロール固定を解除し、位置を復元する
		 */
		_unlockScroll: function() {
			if(location.pathname.indexOf('iphone') !== -1){
				//'iphone'つきのURLを参照していたらSPと判定
				$('body').css('min-height', '');
				$('body').css('overflow', '');
				// $('body').css('position', '');
				// $('body').css('width', '');
				// $('body').css('top', '');
			} else {
				//それ以外は全てPCと判定
				$('body').css('overflow', '');
			}
			$(window).scrollTop(this._currentScrollY);
		}
	};

	/** 規約モーダル 開くイベント */
	$(document).on('click', '.js-policy-modal-open', function(){
		PolicyModal.open($(this), $('#js-policy-modal'), null, null);
	});

	/** 規約モーダル 閉じるイベント(オーバーレイ) */
	$(document).on('click', '.js-policy-modal-window-box', function(){
		if ($('.js-policy-modal-window-box').is(':visible') && $('.js-policy-modal-window-box-inner').is(':visible') && $('body').find('.js-loading-popup').length == 0) {
			PolicyModal.close();
		}
	});
	/** 規約モーダル 閉じるイベント(×ボタン) */
	$(document).on('click', '.js-policy-modal-window-close', function(){
		if ($('.js-policy-modal-window-box').is(':visible') && $('.js-policy-modal-window-box-inner').is(':visible') && $('body').find('.js-loading-popup').length == 0) {
			PolicyModal.close();
		}
	});
}

/**
 * ページロード後に処理を走らせる
 */
$(function(){
	registPolicyModalEvent();
});